import { Bodies, Engine, Render, Body, Events, Constraint, Composite, Runner } from 'matter-js';

export class BaseDrawer {
  constructor() {
    this.engine = Engine.create({
      timing: {
        timeScale: 1,
      },
    });
    this.render = null; // Initialize render to avoid undefined errors
  }

  createApplication(rootRef, configs = {}) {
    const { width, height, gravityY } = configs;
    if (this.render) {
      Render.stop(this.render);
      this.render.canvas.remove();
      this.render = null;
    }

    this.render = Render.create({
      element: rootRef.current,
      engine: this.engine,
      options: {
        width: width,
        height: height,
        wireframes: false,
        background: 'transparent',
        hasBounds: true,
      },
    });
    this.runner = Runner.create();
    Render.run(this.render);
    Runner.run(this.runner, this.engine);
    this.engine.world.gravity.y = gravityY;
  }

  setCollisionStartEvents(collisionCallbacks) {
    Events.on(this.engine, 'collisionStart', collisionCallbacks);
  }

  addEvents(body, eventName, func) {
    return Events.on(body, eventName, func);
  }

  removeEvents(body, eventName, func) {
    Events.off(body, eventName, func);
  }

  createCircle(x, y, radius, options = {}, addImmediately = false) {
    options.isStatic = options.isStatic || false;
    options.sleepThreshold = options.sleepThreshold || 60;
    const texture = Bodies.circle(x, y, radius, options);
    if (addImmediately) {
      this.addToWorld(texture);
    }
    return texture;
  }

  addToWorld(...textures) {
    Composite.add(this.engine.world, textures);
  }

  removeFromWorld(texture) {
    Composite.remove(this.engine.world, texture);
  }

  setVelocity(texture, configs = { x: 0, y: 0 }) {
    Body.setVelocity(texture, configs);
  }

  setAngularSpeed(texture, angularSpeed) {
    Body.setAngularSpeed(texture, angularSpeed);
  }

  updateEngine(value) {
    Engine.update(this.engine, value);
  }

  createConstraint(options, addImmediately = false) {
    const constraint = Constraint.create(options);
    if (addImmediately) {
      this.addToWorld(constraint);
    }
    return constraint;
  }

  createRectangle(x, y, width, height, options) {
    options.isStatic = options.isStatic || false;
    options.sleepThreshold = options.sleepThreshold || 60;
    return Bodies.rectangle(x, y, width, height, options);
  }

  setPosition(body, newX, newY) {
    return Body.setPosition(body, { x: newX, y: newY });
  }
}
